import styled from "styled-components";

import { Box, Button } from "@braze/beacon-core";
import { getSpacing } from "@braze/beacon-styling";

export const PhoneNumberInput = styled(Box)`
  flex: 1 1 auto;
`;

export const CodeVerificationButton = styled(Button)`
  margin-bottom: ${getSpacing("sm")};
`;
